import { useParams, Navigate, useLocation } from 'react-router-dom';

/**
 * SubsidyRedirect - Redirects legacy English URLs to French URLs
 * Handles: /subsidies/:id → /subventions/:id
 *         /subsidy/:id → /subventions/:id
 *         /subsidies/:id/apply → /subventions/:id/postuler
 */
export const SubsidyRedirect = () => {
  const { subsidyId } = useParams<{ subsidyId: string }>();
  const location = useLocation();

  // Check if this is an apply route
  const isApplyRoute = location.pathname.includes('/apply');

  // Redirect to French URL with proper parameter
  const targetPath = isApplyRoute
    ? `/subventions/${subsidyId}/postuler`
    : `/subventions/${subsidyId}`;

  return <Navigate to={targetPath} replace />;
};